import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment, { Moment } from 'moment';
import { CannotOpenSession, CannotReadVitale, CpxCard, MultipleVitaleCards, NoVitaleCard, VitaleCardRipped } from 'src/app/services/cpx-handle/cpx-handle.error';
import { CpxHandleServiceAbstract } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
// import { DmpServiceAbstract } from 'src/app/services/dmp/dmp-service.abstract';
import { ModalService } from 'src/app/services/modal/modal.service';
import { Adresse } from 'src/app/utils/interfaces/new/adresse.interface';
import { DmpSexEnum } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-params.interface';
import { DmpHlFindPatientResponse } from 'src/app/utils/interfaces/new/dmp-hl-find-patient-response.interface';
import { DmpHlGetCertifiedIdentityResponse } from 'src/app/utils/interfaces/new/dmp-hl-get-certified-identity-response.interface';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';
import { LectureCarteVitale } from 'src/app/utils/interfaces/new/lecture-carte-vitale';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';

interface PatientTableDisplay {
  lastName: string;
  birthday: string;
  sex: string;
  city: string;
  zip: string;
  percentageMatch: string;
  selectPatient: string;
  ins: string;
  meta: DmpHlFindPatientResponse;
}

@Component({
  selector: 'app-search-patient',
  templateUrl: './search-patient.component.html',
  styleUrls: ['./search-patient.component.scss']
})
export class SearchPatientComponent implements OnInit {

  @Input() public set currentPatient(value: InfosPatient) {
    // On initialise le formulaire
    this._initForm();

    if (value && value.nom) {
      this.formGroup.get('patientName').setValue(value.nom);
    } else if (value && (!value.nom || value.nom === '') && value.nomNaissance && value.nomNaissance !== '') {
      this.formGroup.get('patientName').setValue(value.nomNaissance);
    }

    if (value && value.prenom) {
      this.formGroup.get('patientFirstname').setValue(this._strUtilsSrv.uppercaseFirstCharString(value.prenom));
    }

    if (value && value.dateNaissance) {
      this.formGroup.get('birth').setValue(moment(value.dateNaissance));
    }

    if (value && value.sexe && value.sexe === 'FEMME') {
      this.formGroup.get('sex').setValue('Féminin');
    } else if (value && value.sexe && value.sexe === 'HOMME') {
      this.formGroup.get('sex').setValue('Masculin');
    } else {
      this.formGroup.get('sex').setValue('Indéterminé');
    }
  }
  @Input() public set currentPatientAddress(address: Adresse) {
    // On initialise le formulaire
    this._initForm();

    if (address && address.codePostal && address.codePostal !== '') {
      this.formGroup.get('zip').setValue(address.codePostal);
    }

    if (address && address.ville && address.ville !== '') {
      this.formGroup.get('city').setValue(address.ville);
    }
  }
  @Output('selectPatient') private _selectPatient = new EventEmitter<DmpHlGetCertifiedIdentityResponse>();

  public formGroup: FormGroup;
  public sexValues: Array<{ id: string, libelle: string }> = [];
  public patientsTable: Paginated<PatientTableDisplay>;
  public patientsTableColumnTable = [
    { title: 'Nom de naissance', data: 'lastName' },
    { title: 'Date de naissance', data: 'birthday' },
    { title: 'Sexe', data: 'sex' },
    { title: 'Commune de résidence', data: 'city' },
    { title: 'Code postal de résidence', data: 'zip' },
    { title: 'Pourcentage de correspondance', data: 'percentageMatch' },
    { title: '', data: 'selectPatient' }
  ];
  private _patients: Array<DmpHlFindPatientResponse> = [];

  constructor(
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _formBuilder: FormBuilder,
    // private _dmpSrv: DmpServiceAbstract,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _router: Router,
    private _strUtilsSrv: StringUtilsService
  ) {
    // const currentProfilStr = localStorage.getItem('currentProfil');
    // if (currentProfilStr && currentProfilStr !== '') {
    //   const currentProfil = JSON.parse(currentProfilStr);
    //   this._dmpSrv.resourceId = currentProfil.id;
    // }
  }

  ngOnInit(): void {
    this._initData();
  }

  public async searchPatients(event: any): Promise<void>{
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      const patientName = this.formGroup.get('patientName').value;
      const patientFirstname = this.formGroup.get('patientFirstname').value;
      const sex = this.formGroup.get('sex').value;
      const birth = this.formGroup.get('birth').value as Moment;
      const zip = this.formGroup.get('zip').value;
      const city = this.formGroup.get('city').value;
      const approxNamePatient = this.formGroup.get('approxNamePatient').value;
      const approxNameCity = this.formGroup.get('approxNameCity').value;

      // On vérifie qu'au moins un criètre de recherche soit renseigné
      if ((!patientName || patientName === '') && (!patientFirstname || patientFirstname === '')
      && (!sex || sex === '') && (!birth || !birth.isValid())
      && (!zip || zip === '') && (!city || city === '')) {
        throw {
          message: 'Au moins un critère de recherche doit être renseigné'
        };
      } else {
        // On lance la recherche de DMP
        // const result = await this._dmpSrv.hl_findpatient({
        //   i_approxCity: approxNameCity ? approxNameCity : undefined,
        //   i_approxName: approxNamePatient ? approxNamePatient : undefined,
        //   i_sex: sex ? DmpSexEnum[sex] as any : undefined,
        //   s_birthday: birth ? birth.toDate() : undefined,
        //   s_city: city ? city : undefined,
        //   s_givenName: patientFirstname ? patientFirstname : undefined,
        //   s_name: patientName ? patientName : undefined,
        //   s_postalCode: zip ? zip : undefined,
        // });

        // this._patients = result;
        // this._initTablePatientsDisplay(result);
      }
    } catch (e) {
      if (e.message === 'Le cadre d\'exercice n\'est pas renseigné dans les paramètres') {
        const modal = this._modalSrv.openModalMultipleChoice(
          this._viewContainerRef,
          'Informations manquantes',
          `${e.message}`,
          '',
          [{
            label: 'Accéder aux paramètre de DMP',
            value: 'goToParams'
          }, {
            label: 'Fermer',
            value: 'close',
            backgroundColor: 'var(--darkest-primary)'
          }]
        );

        const sub = modal.instance.closeEmitter.subscribe((val: string) => {
          if (val === 'goToParams') {
            this._router.navigateByUrl('/user/parametres/dmp');
          }
          sub.unsubscribe();
          modal.destroy();
        });
      } else {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          e.message
        );
      }
    } finally {
      loading.destroy();
    }
  }

  public async readVitale(): Promise<void>{
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      const vitale = await this._readVitale();

      for (const p of vitale.Patients) {
        this._patients.push({
          CivilStatus: {
            i_gender: undefined,
            s_given: p.s_given,
            s_name: p.s_name
          },
          Ins: {
            s_ins: p.s_nir,
            s_insType: environment.dmpInsSuffix as 'D' | 'T' | 'N'
          },
          i_matchingPercentage: undefined,
          i_sex: undefined,
          s_birthDay: moment(p.s_birthdayYYYYMMDD, 'YYYYMMDD').toDate(),
          s_birthName: p.s_birthname,
          s_city: undefined,
          s_insC: p.s_insC,
          s_postalCode: undefined,
          i_birthRank: p.i_birthRank
        });
      }

      if (vitale.Patients.length > 1) {
        const vitalePatients: Array<{ label: string; value: string; }> = [];

        for (const vp of vitale.Patients) {
          vitalePatients.push({ label: `${vp.s_birthname} ${vp.s_given}`, value: vp.s_insC });
        }

        const modalChoice = this._modalSrv.openModalMultipleChoice(
          this._viewContainerRef,
          'Sélection patient',
          'Patients associés à cette carte Vitale',
          '',
          vitalePatients
        );
        const sub = modalChoice.instance.closeEmitter.subscribe((choice: string) => {
          this._initTablePatientsDisplay([]);
          if (choice) {
            this._selectPatient.emit(this._getCertifiedIdentityFromArray(choice));
          } else {
            this._patients = [];
          }
          sub.unsubscribe();
        });
      } else {
        this._initTablePatientsDisplay([]);
        this._selectPatient.emit(this._getCertifiedIdentityFromArray(vitale.Patients[0].s_insC));
      }
    } finally {
      loading.destroy();
    }
  }

  public async selectPatientInResultsList(patient: PatientTableDisplay): Promise<void> {
    this._initTablePatientsDisplay([]);
    this._selectPatient.emit(this._getCertifiedIdentityFromArray(patient.ins));
  }

  private async _initData(): Promise<void> {
    const loading = this._modalSrv.openLoading(this._viewContainerRef);

    try {
      // On initialise le tableau de sexes possibles
      Object.keys(DmpSexEnum).filter((v) => {
        if (isNaN(Number(v))) {
          this.sexValues.push({
            id: v,
            libelle: v
          });
        }
      });

      // On initialise le formulaire
      this._initForm();
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        e.message
      );
    } finally {
      loading.destroy();
    }
  }

  private _initForm(): void {
    if (!this.formGroup) {
      this.formGroup = this._formBuilder.group({
        patientName: [''],
        patientFirstname: [''],
        sex: [''],
        birth: [''],
        zip: [''],
        city: [''],
        approxNamePatient: [''],
        approxNameCity: [''],
      });
    }
  }

  private async _readVitale(): Promise<LectureCarteVitale>{
    return new Promise<LectureCarteVitale>(async (resolve, reject) => {
      try {
        resolve(await this._cpxHandleSrv.lectureVitale(this._viewContainerRef));
      } catch (e) {
        const slotRetry = await this._handleVitaleErrors(e);
        if (slotRetry) {
          resolve(await this._cpxHandleSrv.lectureVitale(this._viewContainerRef, slotRetry));
        } else {
          reject(e);
        }
      }
    });
  }

  private _initTablePatientsDisplay(patientsFound: Array<DmpHlFindPatientResponse>): void {
    const convertPatientToListElem = (patient: DmpHlFindPatientResponse): PatientTableDisplay => {
      const sexes: Array<string> = [];
      Object.keys(DmpSexEnum).filter((s) => {
        if (isNaN(Number(s))) {
          sexes.push(s);
        }
      });

      return {
        birthday: moment(patient.s_birthDay, 'YYYYMMDD').format('DD/MM/yyyy'),
        city: patient.s_city,
        ins: patient.s_insC,
        lastName: patient.CivilStatus.s_name,
        percentageMatch: patient.i_matchingPercentage.toString(),
        sex: sexes [patient.i_sex - 1],
        zip: patient.s_postalCode,
        meta: patient,
        selectPatient: 'Consulter ce DMP'
      };
    };

    // On réinitialise le tableau d'affichage
    if (this.patientsTable) {
      this.patientsTable.objects = [];
    }

    const patientsTmp: Array<PatientTableDisplay> = [];
    for (const pf of patientsFound) {
      patientsTmp.push(convertPatientToListElem(pf));
    }

    if (this.patientsTable) {
      this.patientsTable.objects = [...patientsTmp];
      this.patientsTable.page = 0;
      this.patientsTable.perpage = 0;
      this.patientsTable.total = 0;
    } else {
      this.patientsTable = {
        objects: patientsTmp,
        page: 0,
        perpage: 0,
        total: 0
      };
    }
  }

  private _getCertifiedIdentityFromArray(ins: string): DmpHlGetCertifiedIdentityResponse {
    console.log('_getCertifiedIdentityFromArray - ins : ', ins);
    const patient = this._patients.find(p => p.s_insC === ins);
    this._patients = [];
    return this._dmpHlFindPatientResponseToDmpHlGetCertifiedIdentityResponse(patient);
  }

  private _dmpHlFindPatientResponseToDmpHlGetCertifiedIdentityResponse(
    patient: DmpHlFindPatientResponse): DmpHlGetCertifiedIdentityResponse {
    return {
      Ins: patient.Ins,
      s_birthday: patient.s_birthDay,
      s_patientGivenName: patient.CivilStatus.s_given,
      s_patientName: patient.CivilStatus.s_name,
      s_status: 'OK',
      s_insC: patient.s_insC,
      i_birthRank: patient.i_birthRank
    };
  }

  private async _handleVitaleErrors(e: any): Promise<void | string> {
    return new Promise<void | string>(async (resolve) => {
      if (e instanceof CannotOpenSession) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Impossible de se connecter au lecteur de carte.'
        );
        resolve();
      } else if (e instanceof NoVitaleCard) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Pas de carte vitale insérée.'
        );
        resolve();
      } else if (e instanceof MultipleVitaleCards) {
        const slotNames = e.message.split(',');
        const propositions: Array<any> = [];
        for (let slotName of slotNames) {
          propositions.push({ label: slotName, value: slotName });
        }
        const modal = this._modalSrv.openModalMultipleChoice(
          this._viewContainerRef,
          'Plusieurs cartes vitale insérées', 'Plusieurs cartes vitales ont été insérées.', 'Choisissez la carte à lire :',
          propositions
        );
        const modalSub = modal.instance.closeEmitter.subscribe(async (choice: string | null) => {
          if (choice && choice !== '') {
            resolve(choice);
          } else {
            resolve();
          }
          modalSub.unsubscribe();
        });
      } else if (e instanceof VitaleCardRipped) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Carte vitale arrachée.'
        );
        resolve();
      } else if (e instanceof CannotReadVitale) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Impossible de lire la carte vitale.'
        );
        resolve();
      } else if (e instanceof CpxCard) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Aucune carte Vitale détectée'
        );
        resolve();
      } else {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          e.message
        );
        resolve();
      }
    });
  }

}
